import { I18n } from '@calendly/i18n'

import { UpgradeInlineBanner } from '../upgrade_inline_banner'

export const AutomationsFreePlanBanner = () => (
  <UpgradeInlineBanner
    data-testid="automations-free-plan-banner"
    title={I18n.t('publisher.event_type_editor.sections.more_options.notifications.automations_free_plan.title')}
    message={I18n.t('publisher.event_type_editor.sections.more_options.notifications.automations_free_plan.message')}
    explorePlansLabel={I18n.t('publisher.event_type_editor.sections.more_options.notifications.automations_free_plan.explore_plans')}
    featureKey="workflows"
    paywall="workflows_et_editor_automations_banner"
  />
)
